import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { clientLogos } from '../data/clientLogos';
export function ClientLogos() {
  const {
    t
  } = useLanguage();
  return <div className="mt-12 sm:mt-14" data-id="element-11" data-mp="2hre0t8pl1vom">
      {/* Desktop : grille sur une ligne */}
      <ul aria-label={t.logos.label} className="mx-auto hidden max-w-[980px] grid-cols-6 items-center justify-items-center gap-x-6 lg:grid" data-id="element-12" data-mp="2hpbeozrjwmp6">
        {clientLogos.map(logo => <li key={logo.name} className="flex w-full items-center justify-center" data-id="element-13" data-mp="1u1jpivkwwf6h">
            <img src={logo.src} alt={logo.name} loading="lazy" className="h-16 w-auto max-w-full object-contain mix-blend-multiply" data-id="element-14" data-mp="1tzh30liyx46i" />
          </li>)}
      </ul>

      {/* Mobile / tablette : défilement continu */}
      <div className="-mx-5 overflow-hidden sm:-mx-6 lg:hidden" style={{
      maskImage: 'linear-gradient(to right, transparent, #000 12%, #000 88%, transparent)',
      WebkitMaskImage: 'linear-gradient(to right, transparent, #000 12%, #000 88%, transparent)'
    }} data-id="element-15" data-mp="16bpg6nzsx8qz">
        <ul aria-label={t.logos.label} className="rewayz-marquee flex w-max items-center" data-id="element-16" data-mp="1nnv3tw0vfjgh">
          {[...clientLogos, ...clientLogos].map((logo, i) => <li key={`${logo.name}-${i}`} aria-hidden={i >= clientLogos.length ? 'true' : undefined} className="flex w-[130px] shrink-0 items-center justify-center px-3 sm:w-[160px]" data-id="element-17" data-mp="1duw53lbnucj5" data-mpi={i}>
              <img src={logo.src} alt={i >= clientLogos.length ? '' : logo.name} loading="lazy" className="h-14 w-auto max-w-full object-contain mix-blend-multiply sm:h-16" data-id="element-18" data-mp="13zvumplygkd6" />
            </li>)}
        </ul>
      </div>
    </div>;
}